import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#000000] py-8 border-t border-gray-900" data-id="element-133">
      <div className="max-w-2xl mx-auto text-center px-4" data-id="element-134">
        <p className="text-gray-500 text-sm font-body font-medium tracking-wide" data-id="element-135">
          © MegaPack Afrontar la Vejez de Tus Padres
        </p>
        <p className="text-gray-600 text-xs font-body mt-2" data-id="element-136">
          Todos los derechos reservados
        </p>
      </div>
    </footer>;
}